export const enum SoccerKeyPeriod {
  FINISHED = 'finished',
  FIRST_TIME_BREAK = 'firstTimeBreak',
  SECOND_TIME_BREAK = 'secondTimeBreak',
  OVER_TIME_BREAK = 'overTimeBreak',
  PENALTY = 'penalty',
  OVERTIME_AND_PERIOD = 'overtimeAndPeriod',
}
